import { isAction, type Middleware, type PayloadAction } from '@reduxjs/toolkit'
import type { LoginResponse } from '../../api/schema-dtos/AuthDomainDtos'

export const authLocalStorageMiddleware: Middleware = store => next => action => {
  if (isAction(action)) {
    if (action.type === 'authSlice/authReceiveToken') {
      storeAuthInLocalStorage((action as PayloadAction<LoginResponse>).payload)
    } else if (action.type === 'authSlice/authClearToken') {
      clearAuthInLocalStorage()
    }
  }
  return next(action)
}

export const storeAuthInLocalStorage = (loginResponse: LoginResponse): void => {
  // console.log('storeAuthInLocalStorage')
  localStorage.setItem('accessToken', loginResponse.accessToken)
  localStorage.setItem('assetHolderId', loginResponse.assetHolderId.toString())
  localStorage.setItem('userProfileName', loginResponse.userProfileName.toString())
  localStorage.setItem('userSettlementsEnabled', loginResponse.userSettlementsEnabled.toString())
  localStorage.setItem('userPendingSettlementsAvailable', loginResponse.userPendingSettlementsAvailable.toString())
}

export const clearAuthInLocalStorage = (): void => {
  // console.log('clearAuthInLocalStorage')
  localStorage.removeItem('accessToken')
  localStorage.removeItem('assetHolderId')
  localStorage.removeItem('userProfileName')
  localStorage.removeItem('userSettlementsEnabled')
  localStorage.removeItem('userPendingSettlementsAvailable')
  localStorage.removeItem('proxima-auth')
}

export const getLoginResponseFromLocalStorage = (): LoginResponse | null => {
  const accessToken = localStorage.getItem('accessToken')
  const assetHolderId = localStorage.getItem('assetHolderId')
  const userProfileName = localStorage.getItem('userProfileName')
  const userSettlementsEnabled = localStorage.getItem('userSettlementsEnabled')
  const userPendingSettlementsAvailable = localStorage.getItem('userSettlementsEnabled')

  if (accessToken !== null && assetHolderId !== null && userProfileName !== null) {
    console.log(`Hydrate ${assetHolderId}`)
    console.log(`Hydrate ${userSettlementsEnabled}`)
    return {
      accessToken,
      assetHolderId: parseInt(assetHolderId),
      userProfileName,
      userSettlementsEnabled: userSettlementsEnabled === 'true',
      userPendingSettlementsAvailable: userPendingSettlementsAvailable === 'true'
    }
  }

  console.log('Hydrate NONE')
  return null
}
